import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconDocumentFileGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M14.0785 3.65665C14.2483 3.82654 14.3437 4.05688 14.3438 4.29706V12.9856C14.3434 13.3458 14.2002 13.6912 13.9454 13.9458C13.6906 14.2005 13.3452 14.3436 12.985 14.3438H2.10998C1.74956 14.3439 1.40382 14.2009 1.14879 13.9462C0.893765 13.6916 0.750321 13.346 0.750001 12.9856V2.11058C0.749842 1.93192 0.784906 1.75497 0.853187 1.58986C0.921469 1.42476 1.02163 1.27473 1.14794 1.14837C1.27425 1.022 1.42423 0.921773 1.5893 0.853418C1.75438 0.785063 1.93131 0.749921 2.10998 0.75H10.7967C10.9157 0.749946 11.0336 0.773342 11.1436 0.81885C11.2536 0.864359 11.3535 0.931089 11.4377 1.01523L14.0785 3.65665Z"
        transform="translate(0.453125 0.453125)"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 0.75V3.46875C0.75 3.58776 0.773442 3.70561 0.818985 3.81556C0.864528 3.92551 0.931282 4.02541 1.01544 4.10957C1.18539 4.27952 1.4159 4.375 1.65625 4.375H4.375"
        transform="translate(0.453125 0.453125)"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 5.28125C1.2307 5.28125 1.69172 5.09029 2.03163 4.75038C2.37154 4.41047 2.5625 3.94945 2.5625 3.46875V2.5625C2.5625 2.0818 2.37154 1.62078 2.03163 1.28087C1.69172 0.940959 1.2307 0.75 0.75 0.75V5.28125Z"
        transform="translate(2.71875 7.25)"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.65625 0.75C1.4159 0.75 1.18539 0.845479 1.01543 1.01543C0.845479 1.18539 0.75 1.4159 0.75 1.65625V4.375C0.75 4.61535 0.845479 4.84586 1.01543 5.01582C1.18539 5.18577 1.4159 5.28125 1.65625 5.28125C1.8966 5.28125 2.12711 5.18577 2.29707 5.01582C2.46702 4.84586 2.5625 4.61535 2.5625 4.375V1.65625C2.5625 1.4159 2.46702 1.18539 2.29707 1.01543C2.12711 0.845479 1.8966 0.75 1.65625 0.75Z"
        transform="translate(6.34375 7.25)"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5625 0.75C2.0818 0.75 1.62078 0.940959 1.28087 1.28087C0.940959 1.62078 0.75 2.0818 0.75 2.5625V3.46875C0.75 3.94945 0.940959 4.41047 1.28087 4.75038C1.62078 5.09029 2.0818 5.28125 2.5625 5.28125"
        transform="translate(9.96875 7.25)"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconDocumentFileSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconDocumentFileGroup {...props} />
    </svg>
  );
};
